module.exports = __webpack_public_path__ + "static/media/m_eyeshape_monolid_lightbrown.4924eaea.png";